export const colors = {
	dark: {
		main: "#212121",
		light: "#484848",
		dark: "#000",
		text: "#212121",
		contrastText: "#FFF"
	},
	light: {
		main: "#EEE",
		light: "#FFF",
		dark: "#BCBCBC",
		text: "#EEE",
		contrastText: "#000"
	},
	secondary: {
		main: "#1976d2",
		light: "#4791db",
		dark: "#115293",
		text: "#000",
		contrastText: "#FFF"
	}
} as const;